module.exports = __webpack_public_path__ + "img/office-dark.90201f53.jpg";